/* Step 11d-3 · Mars Live Run Log V3 finds (31-Oct-2026) — EN + AR.
   7: the sign-off counter at the top of Head Folders counts the head folders only, and says so. */
export default {
  en: {
    s11d3: {
      hfRollup: "Sign-offs (head folders only)",
      hfRollupTitle: "Items in the head folders listed below. Acceptance, planning, risk, completion and the other stages have their own sign-offs.",
    },
  },
  ar: {
    s11d3: {
      hfRollup: "التوقيعات (المجلدات الرئيسية فقط)",
      hfRollupTitle: "البنود في المجلدات الرئيسية المعروضة أدناه. للقبول والتخطيط والمخاطر والإنجاز والمراحل الأخرى توقيعاتها الخاصة.",
    },
  },
};
